import React from 'react'
import { Row, Col, Button } from 'antd'
import BannerImg from '../assets/pay-banner.svg'
import Logo from '../assets/payconstruct-img.svg'
import user from '../assets/user-img1.svg'

import './Banner.scss'

const Banner = props => {
  const {
    logo,
    banner,
    userName,
    bannerText,
    bannerTitle,
    handleRedirectLogin,
    handleHomePage,
  } = props
  return (
    <div>
      <Row>
        <img
          src={!banner ? BannerImg : banner}
          alt="Banner"
          style={{ width: '100%', height: '100%' }}
        />
        <Col span={24}>
          <Row className="header">
            <Col span={12} className="logo">
              <img
                src={!logo ? Logo : logo}
                alt="Payconstruct Logo"
                className="img-logo"
                onClick={handleHomePage}
              />
            </Col>
            <Col span={12} className="txt-login">
              {!userName ? (
                <Button type="text" onClick={handleRedirectLogin}>
                  <div
                    style={{
                      textDecoration: 'underline',
                      fontWeight: 700,
                      marginLeft: '-11px',
                      color: '#fff',
                      fontSize: '12px',
                    }}
                    className="txtLogin"
                  >
                    Log in
                  </div>
                </Button>
              ) : (
                <div
                  style={{
                    fontWeight: 700,
                    marginLeft: '-11px',
                    color: '#fff',
                    fontSize: '12px',
                  }}
                >
                  {userName}
                  <img src={user} alt="User" style={{ marginTop: '-3px' }} className="user-img" />
                </div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="banner-text-row">
        <Col span={24} style={{ textAlign: 'center' }}>
          <div className="banner-text">{!bannerText ? 'Banner Title' : bannerText}</div>
          <div className="banner-subText">{!bannerTitle ? 'Banner Title' : bannerTitle}</div>
        </Col>
      </Row>
    </div>
  )
}

export default Banner
